import React, { useState } from 'react';
import { Plus, Minus } from 'lucide-react';
import './SSS.css';

const SSS = () => {
    const [openIndex, setOpenIndex] = useState(null);

    const faqData = [
        {
            question: "Başvuru sürecim ne kadar sürer?",
            answer: "Başvuru süreciniz ortalama 5-7 iş günü içerisinde değerlendirilir ve tarafınıza mail yoluyla dönüş sağlanır."
        },
        {
            question: "Başvuru belgelerimi nasıl güncelleyebilirim?",
            answer: "Belgelerinizi e-posta yoluyla ileterek güncelleyebilirsiniz."
        },
        {
            question: "Birden fazla pozisyona başvuru yapabilir miyim?",
            answer: "Evet, aynı anda birden fazla pozisyona başvuru yapabilirsiniz. Her başvuru ayrı ayrı değerlendirilecektir ve uygun görülen pozisyonlar için sizinle iletişime geçilecektir."
        },
        {
            question: "Başvuru sonucumu nasıl öğrenebilirim?",
            answer: "Başvuru sonuçlarınız sisteme kayıtlı mail adresinize gönderilecektir. Ayrıca tarafınıza arama yapılıp bilgilendirileceksiniz."
        },
        {
            question: "Eksik belge tamamlama sürem ne kadardır?",
            answer: "Eksik belge bildirimi yapıldıktan sonra 5 iş günü içerisinde belgelerinizi tamamlamanız gerekmektedir. Bu süre içinde tamamlanmayan başvurular değerlendirmeye alınmayacaktır."
        }
    ];

    const handleToggle = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    return (
        <div className="corporate-sss-container">
            <h2 className="corporate-sss-title">Sıkça Sorulan Sorular</h2>
            
            <div className="corporate-sss-list">
                {faqData.map((faq, index) => {
                    const isOpen = openIndex === index;
                    return (
                        <div key={index} className={`corporate-sss-item ${isOpen ? 'is-open' : ''}`}>
                            <button
                                className="corporate-sss-button"
                                onClick={() => handleToggle(index)}
                                aria-expanded={isOpen}
                            >
                                <span className="corporate-sss-question">{faq.question}</span>
                                <span className="corporate-sss-icon">
                                    {isOpen ? <Minus size={18} strokeWidth={2.5} /> : <Plus size={18} strokeWidth={2.5} />}
                                </span>
                            </button>
                            
                            <div className="corporate-sss-answer-wrapper">
                                <div className="corporate-sss-answer-inner">
                                    <div className="corporate-sss-answer">
                                        {faq.answer}
                                    </div>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default SSS;